import useFetch from '@hooks/useFetch';

const useLiveClassAndCourseList = () => {
  const { data: liveClassesAndCourses } = useFetch(
    'sheldon/v1/live_class/all',
    undefined,
    {
      revalidateOnMount: true,
      dedupingInterval: 60 * 1000
    }
  );

  const formattedCourseData = (liveClassesAndCourses?.courseUids || []).reduce(
    (acc, curr) => ({ ...acc, [curr]: true }),
    {}
  );

  const formattedClassData = (liveClassesAndCourses?.classUids || []).reduce(
    (acc, curr) => ({ ...acc, [curr]: true }),
    {}
  );

  return {
    liveCourseList: formattedCourseData || [],
    liveClassList: formattedClassData || []
  };
};

export default useLiveClassAndCourseList;
